import React, { createContext, useContext, useState, useCallback } from 'react';
import Alert from 'react-bootstrap/Alert';

const AlertContext = createContext();

// Custom hook for easy access to the alert function
export const useAlert = () => useContext(AlertContext);

export const AlertProvider = ({ children }) => {
  const [alerts, setAlerts] = useState([]);

  // Function to display an alert
  const showAlert = useCallback((message, variant = 'success', duration = 2000) => {
    // Generate a simple unique id (no extra package required)
    const id = Date.now() + Math.random().toString(36).substr(2, 9);
    const newAlert = { id, message, variant };

    // Add new alert
    setAlerts(prev => [...prev, newAlert]);

    // Remove alert after 'duration' milliseconds
    setTimeout(() => {
      setAlerts(prev => prev.filter(alert => alert.id !== id));
    }, duration);
  }, []);

  return (
    <AlertContext.Provider value={showAlert}>
      {children}
      {/* Container for alerts */}
      <div
        style={{
          position: 'fixed',
          top: 150,
          right: 20,
          zIndex: 1060,
          width: '300px'
        }}
      >
        {alerts.map(alert => (
          <Alert
            key={alert.id}
            variant={alert.variant}
            onClose={() => setAlerts(prev => prev.filter(a => a.id !== alert.id))}
            dismissible
            className="mb-2"
          >
            {alert.message}
          </Alert>
        ))}
      </div>
    </AlertContext.Provider>
  );
};

